import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import { SHOOTER_MARK_CATEGORIES, shooterMarkTitle } from '../../lib/shooterMarkCategories';

// Officials-only mark icons next to a shooter's name on standplass/lag rows.
// Non-officials never get mark data (the API 403s the load), so the list is
// empty and nothing renders for them even if canEdit is passed incorrectly.
@observer
class ShooterMarkBadges extends Component {
    openEditor = (e) => {
        // The parent cell often has its own onClick (editParticipant) — the
        // flag must not trigger it.
        e.preventDefault();
        e.stopPropagation();
        const { stores, conventionId, userId, userName } = this.props;
        const { appState } = stores;
        const { drawerHeightMediumLarge } = appState;
        appState.openDrawer('conventionShooterMarkEditor', {
            conventionId,
            userId,
            userName,
            height: drawerHeightMediumLarge,
        });
    }

    render() {
        const { stores, userId, canEdit } = this.props;
        const { shooterMarkStore } = stores;
        const mark = shooterMarkStore.getMarkForUser(userId);
        const active = SHOOTER_MARK_CATEGORIES.filter(cat => (mark?.categories || []).includes(cat.name));
        if (!canEdit && active.length === 0) {
            return null;
        }
        return (
            <span
                class='ms-1 text-nowrap'
                style={canEdit ? 'cursor: pointer;' : ''}
                title={shooterMarkTitle(mark)}
                onClick={canEdit ? this.openEditor : undefined}
            >
                {active.map(cat => (
                    <i key={cat.name} class={`${cat.icon} ${cat.textClass} ms-1`} style='font-size: 0.8rem;' />
                ))}
                {canEdit && active.length === 0 && (
                    <i class='fa-duotone fa-flag ms-1 text-body-tertiary' style='font-size: 0.7rem;' />
                )}
            </span>
        );
    }
}

export default ShooterMarkBadges;
